'use client';
import { createContext, ReactNode, Dispatch } from 'react';

import { BrokerAction } from '@/components/context/ContextBroker/ContextBroker';
import { useContextBroker } from '@/components/context/ContextBroker/useContextBroker';

import { noop } from '@/util/misc';

export type SearchBrokerActions = {
  search: (searchValue: string) => void;
  clearSearch: () => void;
};

type SearchBrokeredValue = {
  value: null | string;
  actions: SearchBrokerActions;
};

export const INITIAL_SEARCH_VALUE = null;

export const SearchContext = createContext<SearchBrokeredValue>({
  value: INITIAL_SEARCH_VALUE,
  actions: {
    search: noop,
    clearSearch: noop
  }
});

type SearchProviderProps = {
  children: ReactNode;

  dispatch: Dispatch<BrokerAction>;
};

function SearchProvider(props: SearchProviderProps) {
  const { children, dispatch } = props;
  const brokerValue = useContextBroker();

  const decoratedValue: SearchBrokeredValue = {
    value: brokerValue.searchValue,
    actions: {
      /**
       * Adds the passed in SKU to the user's Search.
       */
      search: (searchValue: string) => {
        dispatch({
          type: 'SEARCH',
          searchValue
        });
      },

      clearSearch: () => {
        dispatch({
          type: 'SEARCH_CLEAR'
        });
      }
    }
  };

  return (
    <SearchContext.Provider value={decoratedValue}>
      {children}
    </SearchContext.Provider>
  );
}

export default SearchProvider;
